import state from './state'
import mutation from './mutation'

export default {
  state,
  mutation
}
